import { CybermetrieService } from "@oel/js-cybermetrie";
import { CybermetrieParamsAMC } from "../models/CybermetrieParamsAMC";

export class CybermetriesAMC {
    static EnvoiePageQuestionnaireAMC(cybermetrieParams: CybermetrieParamsAMC) {
        const action = cybermetrieParams.estEmprunteurUnique || cybermetrieParams.estEmprunteurPrimaire ? "etape-2a" : "etape-3a";

        const dimensionsPersonnalisees = new Map<string, string>();
        dimensionsPersonnalisees.set("typeProduit", cybermetrieParams.estNouvelleMarge ? "LineOfCredit" : "LineOfCredit increase")
        dimensionsPersonnalisees.set("typeTransaction", cybermetrieParams.parcours)
        dimensionsPersonnalisees.set("transactionId", cybermetrieParams.noDemande)
        dimensionsPersonnalisees.set("extraAttribut", cybermetrieParams.estEmprunteurUnique ? "emprunteurUnique" : "coemprunteur")

        CybermetrieService.envoyerEvenement({
            event: "interractionsPages",
            action: action,
            category: "Formulaire",
            label: cybermetrieParams.estNouvelleMarge ? "frm - obtenir du financement - marge de credit assurance" : "frm - augmentation limite marge de credit assurance"
        }, dimensionsPersonnalisees)
    }

    static EnvoieObtenirReponseAMC(cybermetrieParams: CybermetrieParamsAMC) {
        const dimensionsPersonnalisees = new Map<string, string>();
        dimensionsPersonnalisees.set("typeProduit", cybermetrieParams.estNouvelleMarge ? "LineOfCredit" : "LineOfCredit increase")
        dimensionsPersonnalisees.set("typeTransaction", cybermetrieParams.parcours)
        dimensionsPersonnalisees.set("transactionId", cybermetrieParams.noDemande)
        dimensionsPersonnalisees.set("extraAttribut", cybermetrieParams.estEmprunteurUnique ? "emprunteurUnique" : "coemprunteur")

        CybermetrieService.envoyerEvenement({
            event: "interractionsPages",
            action: "Clic",
            category: "Obtenir du financement",
            label: cybermetrieParams.estNouvelleMarge ? "obtenir du financement - marge de credit assurance - obtenir une reponse" : "augmentation limite marge de credit assurance - obtenir reponse"
        }, dimensionsPersonnalisees)
    }

    static EnvoieAffichageReponseAMC(cybermetrieParams: CybermetrieParamsAMC, decision: string) {
        const dimensionsPersonnalisees = new Map<string, string>();
        dimensionsPersonnalisees.set("typeProduit", cybermetrieParams.estNouvelleMarge ? "LineOfCredit" : "LineOfCredit increase")
        dimensionsPersonnalisees.set("typeTransaction", cybermetrieParams.parcours)
        dimensionsPersonnalisees.set("transactionId", cybermetrieParams.noDemande)
        dimensionsPersonnalisees.set("extraAttribut", cybermetrieParams.estEmprunteurUnique ? "emprunteurUnique" : "coemprunteur")
        dimensionsPersonnalisees.set("extraAttribut2", decision)

        CybermetrieService.envoyerEvenement({
            event: "interractionsPages",
            action: "complete",
            category: "Formulaire",
            label: cybermetrieParams.estNouvelleMarge ? "frm - obtenir du financement - marge de credit assurance" : "frm - augmentation limite marge de credit assurance"
        }, dimensionsPersonnalisees)
    }

    static EnvoiePlanifierAppelAMC(cybermetrieParams: CybermetrieParamsAMC) {
        const dimensionsPersonnalisees = new Map<string, string>();
        dimensionsPersonnalisees.set("typeProduit", cybermetrieParams.estNouvelleMarge ? "LineOfCredit" : "LineOfCredit increase")
        dimensionsPersonnalisees.set("typeTransaction", cybermetrieParams.parcours)
        dimensionsPersonnalisees.set("transactionId", cybermetrieParams.noDemande)
        dimensionsPersonnalisees.set("extraAttribut", cybermetrieParams.estEmprunteurUnique ? "emprunteurUnique" : "coemprunteur")

        CybermetrieService.envoyerEvenement({
            event: "interractionsPages",
            action: "Clic",
            category: "Obtenir du financement",
            label: cybermetrieParams.estNouvelleMarge ? "obtenir du financement - marge de credit assurance - planifier un appel" : "augmentation limite marge de credit assurance - planifier un appel"
        }, dimensionsPersonnalisees)
    }

    static EnvoieAffichagePageValidation(cybermetrieParams: CybermetrieParamsAMC) {
        const dimensionsPersonnalisees = new Map<string, string>();
        dimensionsPersonnalisees.set("typeProduit", cybermetrieParams.estNouvelleMarge ? "LineOfCredit" : "LineOfCredit increase")
        dimensionsPersonnalisees.set("typeTransaction", cybermetrieParams.parcours)
        dimensionsPersonnalisees.set("transactionId", cybermetrieParams.noDemande)
        dimensionsPersonnalisees.set("extraAttribut", cybermetrieParams.estEmprunteurUnique ? "emprunteurUnique" : "coemprunteur")

        CybermetrieService.envoyerEvenement({
            event: "interractionsPages",
            action: "validation",
            category: "Formulaire",
            label: cybermetrieParams.estNouvelleMarge ? "frm - obtenir du financement - marge de credit assurance" : "frm - augmentation limite marge de credit assurance"
        }, dimensionsPersonnalisees)
    }

    static EnvoieModifierQuestionsAMC(cybermetrieParams: CybermetrieParamsAMC) {
        const dimensionsPersonnalisees = new Map<string, string>();
        dimensionsPersonnalisees.set("typeProduit", cybermetrieParams.estNouvelleMarge ? "LineOfCredit" : "LineOfCredit increase")
        dimensionsPersonnalisees.set("typeTransaction", cybermetrieParams.parcours)
        dimensionsPersonnalisees.set("transactionId", cybermetrieParams.noDemande)
        dimensionsPersonnalisees.set("extraAttribut", cybermetrieParams.estEmprunteurUnique ? "emprunteurUnique" : "coemprunteur")

        CybermetrieService.envoyerEvenement({
            event: "interractionsPages",
            action: "confirmer",
            category: "Formulaire",
            label: cybermetrieParams.estNouvelleMarge ? "frm - obtenir du financement - marge de credit assurance - modifier reponses aux questionnaires" : "frm - augmentation limite marge de credit assurance - modifier reponses aux questionnaires"
        }, dimensionsPersonnalisees)
    }

    static EnvoieEnregistrerQuitterAMC(cybermetrieParams: CybermetrieParamsAMC) {
        const dimensionsPersonnalisees = new Map<string, string>();
        dimensionsPersonnalisees.set("typeProduit", cybermetrieParams.estNouvelleMarge ? "LineOfCredit" : "LineOfCredit increase")
        dimensionsPersonnalisees.set("typeTransaction", cybermetrieParams.parcours)
        dimensionsPersonnalisees.set("transactionId", cybermetrieParams.noDemande)
        dimensionsPersonnalisees.set("extraAttribut", cybermetrieParams.estEmprunteurUnique ? "emprunteurUnique" : "coemprunteur")

        CybermetrieService.envoyerEvenement({
            event: "interractionsPages",
            action: "confirmer",
            category: "Formulaire",
            label: cybermetrieParams.estNouvelleMarge ? "frm - obtenir du financement - marge de credit assurance - enregistrer et quitter" : "frm - augmentation limite marge de credit assurance - enregistrer et quitter"
        }, dimensionsPersonnalisees)
    }

    static EnvoieAnnulerDemandeAMC(cybermetrieParams: CybermetrieParamsAMC) {
        const dimensionsPersonnalisees = new Map<string, string>();
        dimensionsPersonnalisees.set("typeProduit", cybermetrieParams.estNouvelleMarge ? "LineOfCredit" : "LineOfCredit increase")
        dimensionsPersonnalisees.set("typeTransaction", cybermetrieParams.parcours)
        dimensionsPersonnalisees.set("transactionId", cybermetrieParams.noDemande)
        dimensionsPersonnalisees.set("extraAttribut", cybermetrieParams.estEmprunteurUnique ? "emprunteurUnique" : "coemprunteur")

        CybermetrieService.envoyerEvenement({
            event: "interractionsPages",
            action: "confirmer",
            category: "Formulaire",
            label: cybermetrieParams.estNouvelleMarge ? "frm - obtenir du financement - marge de credit assurance - annuler la demande" : "frm - augmentation limite marge de credit assurance - annuler la demande"
        }, dimensionsPersonnalisees)
    }
}